export const renewableStages = [
  'originacion',
  'prefactibilidad',
  'permisologia',
  'rtb',
  'ntp'
];

export const renewableStageLabels = {
  originacion: 'Originacion',
  prefactibilidad: 'Prefactibilidad',
  permisologia: 'Permisologia',
  rtb: 'RTB',
  ntp: 'NTP'
};

export const renewableProjects = [];
export const renewablePermits = [];
export const renewableRisks = [];
export const renewableMilestones = [];
